"use client";
import React, { createContext, useContext, ReactNode } from "react";
import { AppRouteContext, AppRouteProps } from "types/provider/Route";
import useRoute from "hooks/useNextRoute";
import routeStore from "utils/routeStore";
import { useSearchParams, usePathname } from "next/navigation";
export const RouteContext = createContext<AppRouteContext>({});
export { useSearchParams, usePathname };
interface TypeUseRouteContext {
  (): AppRouteContext;
}

const RouteProvider = ({ children, ...props }: AppRouteProps): ReactNode => {
  const router = useRoute();
  return (
    <RouteContext.Provider value={{ router, routeStore }}>
      {children}
    </RouteContext.Provider>
  );
};
export const useRouteContext: TypeUseRouteContext = () => {
  return useContext(RouteContext);
};
export default RouteProvider;
